module.exports = __webpack_public_path__ + "static/media/Natural Product Profile.29437d38.png";